module.exports = __webpack_public_path__ + "diasDeGuardia.png";